import React from 'react';
import { useLanguage } from '../i18n/LanguageProvider';

const LanguageSwitcher = ({ className = '' }) => {
  const { language, changeLanguage } = useLanguage();

  const handleLanguageChange = (e) => {
    changeLanguage(e.target.value);
  };

  return (
    <div className={`flex items-center ${className}`}>
      {/* Enhanced Dropdown with Custom Arrow */}
      <div className="relative">
        <select
          value={language}
          onChange={handleLanguageChange}
          className="text-sm border border-gray-300 rounded-lg px-4 py-2 pr-8 bg-white text-gray-800 hover:border-gray-400 hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-all duration-200 cursor-pointer shadow-sm hover:shadow-md font-medium appearance-none"
        >
          <option value="en">English</option>
          <option value="es">Español</option>
        </select>
        {/* Custom Down Arrow */}
        <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
          <svg 
            className="w-4 h-4 text-gray-500" 
            fill="none" 
            stroke="currentColor" 
            viewBox="0 0 24 24"
          >
            <path 
              strokeLinecap="round" 
              strokeLinejoin="round" 
              strokeWidth={2} 
              d="M19 9l-7 7-7-7" 
            />
          </svg>
        </div>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
